import { adminState, initAdmin, getApi, http, adminGet, adminDelete, adminPost, adminPut } from './useAdminCore';
import { getFactoids, createFactoid, updateFactoid, deleteFactoid, getSources, createSource, updateSource, deleteSource, testSource, getGuides, createGuide, updateGuide, deleteGuide, getFaqs, createFaq, updateFaq, deleteFaq, getWalkthroughs, createWalkthrough, updateWalkthrough, deleteWalkthrough, getQuizzes, createQuiz, updateQuiz, deleteQuiz, resetQuizDates, getConfigFiles, getConfigFileContent, saveConfigFile, deleteConfigFile, getFiles, uploadFileChunk, deleteFile } from './useAdminContent';
import { getEmployers, getEmployerDetails, getFreeLicenses, createEmployer, updateEmployer, uploadKeys, removeKeys, deleteEmployer, uploadEmployerKnowledgeBase, getEmployerKnowledgeBaseFiles, deleteEmployerKnowledgeBaseFile, getMemberGetMemberConfiguration, saveMemberGetMemberConfiguration, getCustomers, getSelf, getCustomerCreditTransactions, addCustomerCredit, postFactCard, generateMoves, getCustomerDetails, getCustomerPolicies, getCustomerInvestments, getCustomerMoves, getCustomerCompletedMoves, linkEmployerToCustomer, getDocuments, retryDocument, getCustomerNotes, createCustomerNote, updateCustomerNote, getMoves, createMove, updateMove, deleteMove, getMoveCriteria } from './useAdminEntities';
import { getCategories, createCategory, updateCategory, deleteCategory, uploadCategoryImage, getVouchers, updateVoucher, getDiscountReport, getPaymentReport, getMerchants, saveMerchant, deleteMerchant, getProducts, saveProduct, deleteProduct, getTransactionClassifications, getEffectiveClassifications, getOpenBankingClassifications, createTransactionClassification, updateTransactionClassification, deleteTransactionClassification, remapOpenBankingClassification, getLogoSearchOverrides, createLogoSearchOverride, updateLogoSearchOverride, deleteLogoSearchOverride } from './useAdminCommerce';
import { getPreLoadInstructions, createPreLoadInstruction, updatePreLoadInstruction, deletePreLoadInstruction, getContextAppActions, createContextAppAction, updateContextAppAction, deleteContextAppAction, sendChatMessage, getChatMessages } from './useAdminChat';
import { getCacheStats, getCacheLog, getQueueCount, getCachedUrl, processQueue, flushUrl, clearCache, clearCacheStats, deleteUrl } from './useAdminCache';
import { getSystemStatus, saveSystemStatus } from './useAdminSystem';
export function useAdmin() {
    initAdmin();
    return {
        // State
        adminState,
        // Core helpers
        adminGet, adminDelete, adminPost, adminPut, getApi, http,
        // Factoids
        getFactoids, createFactoid, updateFactoid, deleteFactoid,
        // Sources
        getSources, createSource, updateSource, deleteSource, testSource,
        // Employers
        getEmployers, getEmployerDetails, getFreeLicenses, createEmployer, updateEmployer,
        uploadKeys, removeKeys, deleteEmployer,
        uploadEmployerKnowledgeBase, getEmployerKnowledgeBaseFiles, deleteEmployerKnowledgeBaseFile,
        getMemberGetMemberConfiguration, saveMemberGetMemberConfiguration,
        // Customers
        getCustomers, getSelf, getCustomerCreditTransactions, addCustomerCredit,
        postFactCard, generateMoves, getCustomerDetails, getCustomerPolicies,
        getCustomerInvestments, getCustomerMoves, getCustomerCompletedMoves, linkEmployerToCustomer,
        // Documents
        getDocuments, retryDocument,
        // CMS Files
        getFiles, uploadFileChunk, deleteFile,
        // Categories
        getCategories, createCategory, updateCategory, deleteCategory, uploadCategoryImage,
        // Guides
        getGuides, createGuide, updateGuide, deleteGuide,
        // Vouchers
        getVouchers, updateVoucher, getDiscountReport, getPaymentReport,
        // Merchants
        getMerchants, saveMerchant, deleteMerchant, getTransactionClassifications,
        // Marketplace Products
        getProducts, saveProduct, deleteProduct,
        // System Status
        getSystemStatus, saveSystemStatus,
        // Transaction Classifications admin
        getEffectiveClassifications, getOpenBankingClassifications,
        createTransactionClassification, updateTransactionClassification, deleteTransactionClassification,
        remapOpenBankingClassification,
        // Chat / AI
        getPreLoadInstructions, createPreLoadInstruction, updatePreLoadInstruction, deletePreLoadInstruction,
        getContextAppActions, createContextAppAction, updateContextAppAction, deleteContextAppAction,
        sendChatMessage, getChatMessages,
        // Customer Notes
        getCustomerNotes, createCustomerNote, updateCustomerNote,
        // Moves (PSMs)
        getMoves, createMove, updateMove, deleteMove, getMoveCriteria,
        // Cache
        getCacheStats, getCacheLog, getQueueCount, getCachedUrl,
        processQueue, flushUrl, clearCache, clearCacheStats, deleteUrl,
        // Walkthroughs
        getWalkthroughs, createWalkthrough, updateWalkthrough, deleteWalkthrough,
        // FAQs
        getFaqs, createFaq, updateFaq, deleteFaq,
        // Quizzes
        getQuizzes, createQuiz, updateQuiz, deleteQuiz, resetQuizDates,
        // Policy Sections (CMS Configs)
        getConfigFiles, getConfigFileContent, saveConfigFile, deleteConfigFile,
        // Logo Search Overrides
        getLogoSearchOverrides, createLogoSearchOverride, updateLogoSearchOverride, deleteLogoSearchOverride,
    };
}
